// extracted by mini-css-extract-plugin
export var locationsModal = "_redotech-redo-customer-portal-returns-app-lib-returns-components-return-locations-button-locations-modal";